module.exports = __webpack_public_path__ + "img/cases-brand-tommee-12.222dab0e.jpg";